import type {
	CategoriesControllerGetSchoolCategoriesQueryParams
} from '@/global/api/gen/ts/CategoriesDTO/CategoriesControllerGetSchoolCategories';

export const CategoryKeys = {
	all: ['categories'] as const,
	sectionAndTopics: (id:string) => [...CategoryKeys.all, 'sections', 'topics', `${id}`] ,
	searchBySchool: (id:number) => [...CategoryKeys.all, 'search', `${id}`] as const,
	searchBySchoolWithParams:  (id:number, params:CategoriesControllerGetSchoolCategoriesQueryParams) => [...CategoryKeys.searchBySchool(id), params] as const,
};